/**
 * Created by neo on 19.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { RecipeEquipment, createRecipeEquipment } from './RecipeEquipment';
import { LocalizedValue, createLocalizedValue } from '../../LocalizedValue';
import { StringUtils } from '../../../Utils/StringUtils';

export type RecipeInstructionStep = {
  number: number;
  step: LocalizedValue[];
  ingredients: string[];
  equipment: RecipeEquipment[];
  getStepText(language?: string): string;
};

export function createRecipeInstructionStep(json?: Partial<RecipeInstructionStep>): RecipeInstructionStep {
  return makeAutoObservable({
    number: json?.number ?? 0,
    step: (json?.step ?? []).map((l: any) => createLocalizedValue(l)),
    ingredients: json?.ingredients ?? [],
    equipment: (json?.equipment ?? []).map((e: any) => createRecipeEquipment(e)),

    getStepText(language: string = 'de'): string {
      const text =
        this.step.find((n) => n.lang === language)?.value ??
        this.step.find((n) => n.lang === 'en')?.value ??
        (this.step.length > 0 ? this.step[0]?.value : '');
      return StringUtils.capitalize(text || '', false);
    },
  });
}
